import { transition } from '../../_content.style.js';
import { sheetCls, zoomContainer } from '../../organism.sheet/_sheet.style.js';

const applyScrollAnchorToSheet = (containerRef, mode, anchorPoint) => {
  const overflowContainer = (containerRef.current ?? document).querySelector(`.${mode === "fullscreen" ? transition : sheetCls}`);
  const sheet = (containerRef.current ?? document).querySelector(`.${zoomContainer}`);
  if (sheet === null || overflowContainer === null) {
    throw new Error("centerSheet(...): Unable to access sheet for the provided pageIndex.");
  }
  const sheetSize = {
    width: sheet.offsetWidth,
    height: sheet.offsetHeight
  };
  overflowContainer.scrollLeft = sheetSize.width * anchorPoint.x - overflowContainer.clientWidth / 2;
  overflowContainer.scrollTop = sheetSize.height * anchorPoint.y - overflowContainer.clientHeight / 2;
};
function getScrollAnchorPoint(containerRef, mode) {
  const overflowContainer = (containerRef.current ?? document).querySelector(`.${mode === "fullscreen" ? transition : sheetCls}`);
  if (overflowContainer === null) {
    throw new Error("getScrollAnchorPoint(...): Unable to access sheet for the provided pageIndex.");
  }
  const anchorPoint = {
    x: overflowContainer.scrollLeft / (overflowContainer.scrollWidth - overflowContainer.clientWidth),
    y: overflowContainer.scrollTop / (overflowContainer.scrollHeight - overflowContainer.clientHeight)
  };
  return {
    x: isNaN(anchorPoint.x) ? 0.5 : anchorPoint.x,
    y: isNaN(anchorPoint.y) ? 0.5 : anchorPoint.y
  };
}

export { applyScrollAnchorToSheet, getScrollAnchorPoint };
//# sourceMappingURL=apply-scroll-anchor-to-sheet.js.map
